<template>
  <div>
    <Navbar activeDirectory="map" activePage="realtime-map"></Navbar>
    <div class="container-fluid py-4">
      <!-- ===== PAGE HEADER ===== -->
      <div class="d-flex align-items-center justify-content-between flex-wrap mb-4" style="gap:12px;">
        <div class="d-flex align-items-center">
          <div class="au-header-icon mr-3">
            <i class="mdi mdi-map-marker-radius"></i>
          </div>
          <div class="text-left">
            <h3 class="mb-0 font-weight-bold text-dark">Mappa in Tempo Reale</h3>
            <p class="mb-0 text-muted small">Monitora la posizione delle squadre e lo storico interventi</p>
          </div>
        </div>
      </div>

      <div class="au-card p-4">
        <div class="row">
          <div :class="isViewingPath ? 'col-12' : 'col-12 col-lg-8 mb-3 mb-lg-0'" class="position-relative">
                  <div class="position-absolute shadow-sm" style="top: 15px; right: 25px; z-index: 1000; border-radius: 4px; overflow: hidden; background: white;">
                    <button class="btn btn-sm border-0" :class="mapLayer === 'standard' ? 'btn-primary font-weight-bold' : 'btn-light text-muted'" @click="cambiaMappa('standard')"><i class="mdi mdi-map mr-1"></i>Mappa</button>
                    <button class="btn btn-sm border-0" :class="mapLayer === 'satellite' ? 'btn-primary font-weight-bold' : 'btn-light text-muted'" @click="cambiaMappa('satellite')"><i class="mdi mdi-earth mr-1"></i>Satellite</button>
                  </div>

                  <div v-if="isViewingPath" class="position-absolute shadow-sm" style="top: 15px; left: 25px; z-index: 1000; border-radius: 4px; overflow: hidden; background: white;">
                    <button class="btn btn-sm btn-danger font-weight-bold" @click="clearPath()"><i class="mdi mdi-close-circle-outline mr-1"></i> Chiudi Visualizzazione Percorso</button>
                  </div>

                  <l-map
                    ref="myMap"
                    v-if="mode == 'teams'"
                    style="height: calc(100vh - 280px); width: 100%"
                    class="border"
                    :zoom="zoom"
                    :center.sync="center"
                    @update:zoom="zoomUpdated"
                    @update:center="centerUpdated"
                    @update:bounds="boundsUpdated"
                  >
                    <l-tile-layer :url="currentMapUrl" :maxZoom="maxZoom"></l-tile-layer>
                    <l-geo-json v-if="!isViewingPath && geojson && geojson.type" :geojson="geojson" :options="geojsonOptions"></l-geo-json>
                    <l-polyline v-if="isViewingPath && pathCoords" :lat-lngs="pathCoords" color="#28a745" :weight="8" :opacity="0.9"></l-polyline>
                    <l-geo-json v-if="pathGeojson && pathGeojson.type" :geojson="pathGeojson" :options="pathGeojsonOptions" ref="pathLayer"></l-geo-json>

                    <!-- Start and End Markers -->
                    <l-marker v-if="pathStart" :lat-lng="pathStart">
                      <l-icon :icon-size="[30, 30]" :icon-anchor="[15, 30]" class-name="bg-transparent border-0">
                        <div class="map-marker-premium bg-success shadow-md" style="font-size: 16px;">
                          <i class="mdi mdi-ray-start h6 mb-0 text-white" style="line-height: 1;"></i>
                        </div>
                      </l-icon>
                      <l-popup>Inizio Percorso</l-popup>
                      <l-tooltip>Inizio Percorso</l-tooltip>
                    </l-marker>

                    <l-marker v-if="pathEnd" :lat-lng="pathEnd">
                      <l-icon :icon-size="[30, 30]" :icon-anchor="[15, 30]" class-name="bg-transparent border-0">
                        <div class="map-marker-premium bg-danger shadow-md" style="font-size: 16px;">
                          <i class="mdi mdi-ray-end h6 mb-0 text-white" style="line-height: 1;"></i>
                        </div>
                      </l-icon>
                      <l-popup>Fine Percorso (Ultima Rilevazione)</l-popup>
                      <l-tooltip>Fine Percorso (Ultima Rilevazione)</l-tooltip>
                    </l-marker>

                  </l-map>

                  <l-map v-if="mode=='timeline'" style="height: calc(100vh - 280px); width: 100%"
                    class="border"
                    :zoom="zoom"
                    :center.sync="center"
                    @update:zoom="zoomUpdated"
                    @update:center="centerUpdated"
                    @update:bounds="boundsUpdated">
                    <l-tile-layer :url="currentMapUrl" :maxZoom="maxZoom"></l-tile-layer>

                    <l-marker v-for="item in timelineItems" v-bind:key="item.id" :lat-lng="getLatLng(item)" >
                      <l-icon
                        :icon-size="[36, 36]"
                        :icon-anchor="[18, 18]"
                        class-name="bg-transparent border-0"
                      >
                        <div class="map-marker-premium shadow-md" :class="getTimelineMarkerBg(item)" style="font-size: 20px;">
                          <i class="mdi h5 mb-0 text-white" style="line-height: 1;" :class="getTimelineMarkerIcon(item)"></i>
                        </div>
                      </l-icon>
                      <l-popup>
                        <div class="px-2 py-1">
                          <h6 class="font-weight-bold mb-1 text-uppercase">{{ nomeIntervento(item.intervento) }}</h6>
                          <div class="d-flex align-items-center mb-2">
                             <span class="badge" :class="item.tipo_evento == 'inizio lavoro' ? 'badge-success' : (item.tipo_evento == 'fine lavoro' ? 'badge-info' : 'badge-warning')">{{ item.tipo_evento.toUpperCase() }}</span>
                          </div>
                          <p class="small text-muted mb-2"><i class="mdi mdi-clock-outline mr-1"></i>{{ item.tempo }}</p>
                          <div v-if="item.foto" class="text-center rounded overflow-hidden shadow-sm">
                            <img :src="item.foto" :alt="item.intervento" v-img-fallback style="max-width: 160px; object-fit: cover;">
                          </div>
                        </div>
                      </l-popup>
                      <l-tooltip>
                        <span class="text-capitalize font-weight-bold">{{ nomeIntervento(item.intervento) }}</span>
                      </l-tooltip>
                    </l-marker>
                  </l-map>
                </div>

                <div class="col-12 col-lg-4" v-if="mode=='teams' && !isViewingPath">
                

                  <p v-if="loading" class="mt-2 text-muted"><i class="mdi mdi-loading mdi-spin mr-1"></i> Caricamento posizioni aggiornate...</p>                  

                  <div class="table-responsive" v-else>
                    <table class="au-table">
                      <thead>
                        <tr>
                          <th style="width: 40px;"></th>
                          <th>Squadra in Servizio</th>
                          <th class="text-right">Azioni</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="item in features"
                          :class="[{'bg-primary-light': selectedFeatureId == item.id}]"
                          v-bind:key="item.id"
                        >
                          <td class="align-middle text-center">
                            <i
                              v-if="item.geometry.coordinates[0] != 0 && item.geometry.coordinates[1] != 0"
                              class="mdi h5 mb-0 text-muted"
                              :class="[{'mdi-eye-outline' : !item.properties.hide}, {'mdi-eye-off-outline' : item.properties.hide}]"
                              @click="item.properties.hide=!item.properties.hide"
                              style="cursor: pointer;"
                              v-tooltip="item.properties.hide ? 'Mostra su mappa' : 'Nascondi da mappa'"
                            ></i>
                          </td>
                          <td class="align-middle font-weight-semibold">
                            {{ item.properties.team }}
                          </td>
                          <td class="align-middle text-right">
                            <i
                              v-if="(item.geometry.coordinates[0] != 0 && item.geometry.coordinates[1] != 0) && !item.properties.hide"
                              class="mdi mdi-crosshairs-gps h5 mb-0 text-primary mr-2"
                              style="cursor: pointer;"
                              @click="selectedFeatureId=item.id; setCenter(item.geometry, true)"
                              v-tooltip="'Trova su mappa'"
                            ></i>
                            
                            <i class="mdi mdi-google-maps h5 mb-0 text-success mr-2" style="cursor: pointer;" @click="mostraPercorso(item)" v-tooltip="'Mostra percorso oggi'"></i>
                            <i class="mdi mdi-history h5 mb-0 text-info" style="cursor: pointer;" @click="selectedFeatureId=item.id; mode='timeline'; team=item.properties.team;" v-tooltip="'Storico interventi'"></i>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <button
                    class="btn btn-outline-secondary btn-block mt-3 shadow-sm rounded-pill"
                    v-if="isViewingPath"
                    @click="clearPath()"
                  ><i class="mdi mdi-close-circle-outline mr-1"></i> Chiudi Percorso</button>

                  <button
                    class="btn btn-outline-primary btn-block mt-3 shadow-sm rounded-pill"
                    v-if="mode=='teams'"
                    @click="startLoadFeatures()"
                  ><i class="mdi mdi-refresh mr-1"></i> Aggiorna Posizioni</button>                  
                </div>

                <div class="col-12 col-lg-4" v-if="mode=='timeline'">
                  <div class="d-flex justify-content-between align-items-center mb-3">
                    <h5 class="font-weight-bold mb-0 text-primary">Attività Recenti</h5>
                    <span class="badge badge-soft-primary px-2 font-weight-bold">{{ team }}</span>
                  </div>
                  
                  <p v-if="loading" class="mt-2 text-muted"><i class="mdi mdi-loading mdi-spin mr-1"></i> Caricamento storico...</p>
                  <div class="table-responsive" v-else>
                    <table class="au-table">
                      <thead>
                        <tr>
                          <th>Intervento</th>
                          <th>Fase</th>
                          <th>Orario</th>
                          <th class="text-right">Azione</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="item in timelineItems" v-bind:key="item.id">
                          <td class="align-middle font-weight-semibold text-capitalize" style="cursor: pointer;" @click="mostraDettagli(item)">
                            {{ nomeIntervento(item.intervento) }}
                          </td>
                          <td class="align-middle py-2" style="cursor: pointer;" @click="mostraDettagli(item)">
                             <span class="badge" :class="item.tipo_evento == 'inizio lavoro' ? 'badge-success' : (item.tipo_evento == 'fine lavoro' ? 'badge-info' : 'badge-warning')">{{ item.tipo_evento.toUpperCase() }}</span>
                          </td>                        
                          <td class="align-middle text-muted small" style="cursor: pointer;" @click="mostraDettagli(item)">{{ formatTimeOnly(item.tempo) || item.tempo }}</td>
                          <td class="align-middle text-right pb-3">
                            <i
                              class="mdi mdi-eye-outline h5 mb-0 text-primary mr-2"
                              style="cursor: pointer;"
                              @click="mostraDettagli(item)"
                              v-tooltip="'Dettagli'"
                            ></i>
                            <i
                              class="mdi mdi-crosshairs-gps h5 mb-0 text-info"
                              style="cursor: pointer;"
                              @click="findCenter(item)"
                              v-tooltip="'Trova su mappa'"
                            ></i>
                          </td>                                               
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  
                  <div class="empty-state py-4" v-if="!loading && timelineItems.length === 0">
                    <i class="mdi mdi-timeline-text-outline"></i>
                    <h6>Nessuna attività</h6>
                    <p class="small">Non ci sono eventi recenti per {{ team }}.</p>
                  </div>

                  <button
                    class="btn btn-outline-secondary btn-block mt-3 shadow-sm rounded-pill"
                    v-if="mode=='timeline'"
                    @click="mode='teams'"
                  ><i class="mdi mdi-arrow-left mr-1"></i> Torna a Squadre</button>
                </div>
              </div>
        </div>
      </div>
    <!-- Modale Dettagli Evento -->
    <modal name="dettagli-evento" :adaptive="true" :max-width="850" width="90%" height="auto" :scrollable="true">
      <div v-if="eventoSelezionato && Object.keys(eventoSelezionato).length > 0">
        <div class="card mb-0 border-0">
          <div class="modal-header-premium d-flex justify-content-between align-items-center bg-light p-3 border-bottom">
            <h4 class="mb-0 font-weight-bold text-primary">Dettagli {{ eventoSelezionato.tipo_evento  }}</h4>
            <button class="btn btn-light btn-sm rounded-circle" @click="$modal.hide('dettagli-evento')"><i class="mdi mdi-close"></i></button>
          </div>
          <div class="card-body p-4">
            <div class="row">
              <div class="col-md-5">
                <div class="rounded-lg overflow-hidden shadow-sm mb-3">
                  <img :src="eventoSelezionato.foto" v-img-fallback class="img-fluid w-100" style="object-fit: cover; max-height: 400px; border-radius: 12px; min-height: 200px;">
                </div>
              </div>
              <div class="col-md-7">
                <div class="modal-section-title font-weight-bold mb-2 pb-1 border-bottom text-primary"><i class="mdi mdi-information-outline"></i> Informazioni Generali</div>
                <div class="row mb-3">
                  <div class="col-6 mb-2">
                    <div class="small text-muted font-weight-bold text-uppercase">Tipo Intervento</div>
                    <div class="font-weight-semibold text-capitalize">{{ nomeIntervento(eventoSelezionato.intervento) }}</div>
                  </div>
                  <div class="col-6 mb-2">
                    <div class="small text-muted font-weight-bold text-uppercase">Fase</div>
                    <div class="font-weight-semibold">
                      <span class="badge" :class="eventoSelezionato.tipo_evento == 'inizio lavoro' ? 'badge-success' : (eventoSelezionato.tipo_evento == 'fine lavoro' ? 'badge-info' : 'badge-warning')">{{ eventoSelezionato.tipo_evento.toUpperCase() }}</span>
                    </div>
                  </div>
                  <div class="col-6 mb-2">
                    <div class="small text-muted font-weight-bold text-uppercase">Squadra</div>
                    <div class="font-weight-semibold text-primary"><i class="mdi mdi-account-group mr-1"></i>{{ team }}</div>
                  </div>
                  <div class="col-6 mb-2">
                    <div class="small text-muted font-weight-bold text-uppercase">Orario</div>
                    <div class="font-weight-semibold text-muted small">{{ formatTimestampToLocalDate(eventoSelezionato.tempo) }}</div>
                  </div>
                </div>

                <div class="modal-section-title font-weight-bold mb-2 pb-1 border-bottom text-primary"><i class="mdi mdi-map-marker-outline"></i> Posizione</div>
                <div class="mb-2">
                  <div class="small text-muted font-weight-bold text-uppercase">Indirizzo / Strada</div>
                  <div class="font-weight-semibold">{{ eventoSelezionato.strada || '-' }}</div>
                </div>
                <div class="row mb-3">
                  <div class="col-6">
                    <div class="small text-muted font-weight-bold text-uppercase">Latitudine</div>
                    <div class="font-family-monospace small text-muted">{{ eventoSelezionato.latitudine || '-' }}</div>
                  </div>
                  <div class="col-6">
                    <div class="small text-muted font-weight-bold text-uppercase">Longitudine</div>
                    <div class="font-family-monospace small text-muted">{{ eventoSelezionato.longitudine || '-' }}</div>
                  </div>
                </div>

                <div v-if="eventoSelezionato.note">
                  <div class="modal-section-title font-weight-bold mb-2 pb-1 border-bottom text-primary"><i class="mdi mdi-note-text-outline"></i> Note</div>
                  <div>
                    <p class="text-muted font-italic small mb-0">{{ eventoSelezionato.note }}</p>
                  </div>
                </div>

                <div class="mt-4 text-center" v-if="tipologia == 'B'">
                  <router-link v-if="eventoSelezionato.tipo_evento == 'segnalazione'" :to="{name: 'modifica-segnalazione', params: {uuid: eventoSelezionato.uuid || eventoSelezionato.id}}" class="btn btn-primary px-4 shadow-sm">
                    <i class="mdi mdi-pencil-outline mr-1"></i> Modifica
                  </router-link>
                  <router-link v-else-if="eventoSelezionato.tipo_evento == 'fine lavoro' || eventoSelezionato.tipo_evento == 'inizio lavoro'" :to="{name: 'modifica-lavoro', params: {uuid: eventoSelezionato.uuid}}" class="btn btn-primary px-4 shadow-sm" v-show="eventoSelezionato.uuid">
                    <i class="mdi mdi-pencil-outline mr-1"></i> Modifica Lavoro
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </modal>

  </div>
</template>

<script>
import { latLng, divIcon, marker } from "leaflet";
import { Navbar } from "@/components";
import { nomeIntervento } from "@/utils/intervento";

import { contextStore } from "@/utils/contextStore";

export default {
  components: {
    Navbar,
  },

  data() {
    return {
      mode: 'teams',
      zoom: 9,
      center: undefined,
      bounds: null,
      rotation: 0,
      features: [],
      selectedFeatures: [],
      selectedFeatureId: null,
      loading: false,
      isViewingPath: false,
      pathStart: null,
      pathEnd: null,
      pathCoords: [],
      url_old: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      geojson: null,
      pathGeojson: null,
      timeline: {},
      team: null,
      eventoSelezionato: {},
      tipologia: localStorage.getItem('tipologia'),
      mapLayer: 'standard', // 'standard' o 'satellite'
      maxZoom: 19
    };
  },

  mounted() {
    if (localStorage.getItem("mapLayer")) {
      this.mapLayer = localStorage.getItem("mapLayer");
    }
    this.caricaCommesse();
  },

  created() {
  },

  watch: {
    mode (nv) {
      if (nv==='timeline') {
        this.fetchTimelineData()
      }
    },
    'contextStore.activeCommessaId'() {
      this.fetchGpsData();
      if (this.mode === 'timeline') {
        this.fetchTimelineData();
      }
    }
  },

  computed: {
    contextStore() {
      return contextStore;
    },
    lotto() {
      return contextStore.activeCommessaId || '1';
    },
    commesse() {
      return contextStore.commesse;
    },
    activeCommessa() {
      return contextStore.activeCommessa;
    },
    currentMapUrl() {
      if (this.mapLayer === 'satellite') {
        return "https://mt1.google.com/vt/lyrs=y&x={x}&y={y}&z={z}";
      }
      return this.url;
    },

    geojsonOptions() {
      return {
        onEachFeature: this.onEachGeojsonFeature,
        pointToLayer: function (feature, latlng) {
          if (!feature.properties.hide) {
            let tipologia = feature.properties.tipologia;
            let iconClass = 'mdi-truck';
            let bgClass = 'map-marker-team';
            
            if (tipologia === 'C') { iconClass = 'mdi-car'; bgClass = 'bg-info'; }
            else if (tipologia === 'T') { iconClass = 'mdi-tractor'; bgClass = 'bg-warning'; }
            else if (tipologia === 'S') { iconClass = 'mdi-truck-fast'; bgClass = 'bg-success'; }
            else if (tipologia === '1') { iconClass = 'mdi-road'; bgClass = 'bg-warning'; }
            else if (tipologia === '2') { iconClass = 'mdi-leaf'; bgClass = 'bg-success'; }
            else if (tipologia === '3') { iconClass = 'mdi-wrench'; bgClass = 'bg-secondary'; }
            else if (tipologia === '4') { iconClass = 'mdi-flash'; bgClass = 'bg-danger'; }
            else if (tipologia === '5') { iconClass = 'mdi-eye'; bgClass = 'bg-primary'; }
            else if (tipologia === '6') { iconClass = 'mdi-hammer'; bgClass = 'bg-warning'; }
            else if (tipologia === '7') { iconClass = 'mdi-alert'; bgClass = 'bg-danger'; }
            else if (tipologia === '8') { iconClass = 'mdi-broom'; bgClass = 'bg-info'; }
            else if (tipologia === '9') { iconClass = 'mdi-shield-check'; bgClass = 'bg-success'; }
            
            let htmlStr = `
              <div class="map-marker-premium ${bgClass} shadow-md" style="font-size: 20px;">
                <i class="mdi ${iconClass} h5 mb-0 text-white" style="line-height: 1;"></i>
              </div>
            `;
            let marker_icon = divIcon({
              html: htmlStr,
              className: 'bg-transparent border-0',
              iconSize: [40, 40],
              iconAnchor: [20, 20],
            });
            return marker(latlng, {
              icon: marker_icon,
            });
          }
        },
      };
    },

    pathGeojsonOptions() {
      return {
        style: {
          color: '#28a745',
          weight: 5,
          opacity: 0.9
        }
      };
    },

    onEachGeojsonFeature() {
      return (feature, layer) => {
        let popup_html = `
          <table class="table table-striped table-sm border">
            <tbody>
              <tr>
                <td><b>Squadra</td>
                <td><b>${feature.properties.team}</b></td>
              </tr>
              <tr>
                <td>Latitudine</td>
                <td>${feature.geometry.coordinates[1].toFixed(4)}</td>
              </tr>
              <tr>
                <td>Longitudine</td>
                <td>${feature.geometry.coordinates[0].toFixed(4)}</td>
              </tr>
            </tbody>
          </table>
          <i>Ultima posizione al ${feature.properties.last_update}</i>
        `;
        layer.bindPopup(popup_html, { permanent: false, sticky: true });
        layer.bindTooltip(feature.properties.team, { permanent: false, direction: 'top' });
      };
    },

    timelineItems() {
      let timeline = this.timeline;
      var tItems = [];
      var items = Object.values(timeline)
      for (var i in items) {
        let item = items[i]
        if(item['tipo_evento']=='segnalazione'){
          tItems.push(item);
        } else {
          tItems.push({
            id: item['id'] + '_inizio',
            uuid: item['uuid'],
            tempo: item['inizio'],
            intervento: item['intervento'],
            foto: item['foto_inizio'],
            latitudine: item['latitudine_inizio'],
            longitudine: item['longitudine_inizio'],
            note: item['note'],
            strada: item['strada'],
            tipo_evento: 'inizio lavoro'
          })
          if(item['fine']){
            tItems.push({
              id: item['id'],
              uuid: item['uuid'],
              intervento: item['intervento'],
              tempo: item['fine'],
              foto: item['foto_fine'],
              latitudine: item['latitudine_fine'],
              longitudine: item['longitudine_fine'],
              note: item['note'],
              strada: item['strada'],
              tipo_evento: 'fine lavoro'
            })
          } 
        }
      }
      return tItems;
    }
  },

  methods: {
    nomeIntervento,

    startLoadFeatures() {
      this.loading = true;
      this.getGeojson();
    },

    loadFeatures() {
      return new Promise((resolve) => {
        this.axios.get(`fleet-management/gps-positions/${this.lotto}`).then((response) => {
          resolve(response.data.features);
        });
      });
    },

    getGeojson() {
      this.axios.get(`fleet-management/gps-positions/${this.lotto}`).then((response) => {
        this.features = response.data.features;
        this.geojson = response.data;
        for (var i in response.data.features) {
          let geometry = response.data.features[i].geometry;
          if (geometry.coordinates[0] != 0 && geometry.coordinates[1] != 0) {
            this.setCenter(geometry);
            this.selectedFeatureId = response.data.features[i].id;
            break;
          }
        }

        this.loading = false;
      });
    },

    fetchTimelineData() {
    console.log(`Fetching timeline data for team ID: ${this.selectedFeatureId}`);

    this.loading = true;
    
    this.axios.get(`team/${this.selectedFeatureId}/timeline?limit=10`)
      .then(response => {
        console.log("Timeline data received:", response.data);
        this.timeline = response.data;
      })
      .catch(error => {
        console.error("Error fetching timeline data:", error);
      })
      .finally(() => {
        this.loading = false;
        console.log("Fetch operation completed.");
      });
    },

    mostraPercorso(item) {
      this.selectedFeatureId = item.id;
      this.loading = true;
      this.axios.get(`fleet-management/gps-positions/${item.id}/path`).then((response) => {
        if (response.data && response.data.features && response.data.features.length > 0) {
          const feature = response.data.features[0];
          this.pathGeojson = response.data;
          
          const coords = feature.geometry.coordinates;
          if (coords.length > 0) {
            this.pathCoords = coords.map(c => [c[1], c[0]]); // Convert [lng, lat] to [lat, lng]
            this.pathStart = this.pathCoords[0];
            this.pathEnd = this.pathCoords[this.pathCoords.length - 1];
            this.isViewingPath = true; // Hide other markers
            
            // Auto-zoom to path
            this.$nextTick(() => {
              if (this.$refs.pathLayer && this.$refs.pathLayer.mapObject && this.$refs.myMap) {
                const bounds = this.$refs.pathLayer.mapObject.getBounds();
                if (bounds.isValid()) {
                   this.$refs.myMap.mapObject.fitBounds(bounds, { padding: [50, 50] });
                }
              }
            });
          }
        } else {
          this.$swal.fire('Nessun percorso', `Nessun percorso trovato oggi per ${item.properties.team}`, 'info');
          this.pathGeojson = null;
          this.pathStart = null;
          this.pathEnd = null;
          this.isViewingPath = false;
        }
        this.loading = false;
      }).catch(err => {
        console.error("Error fetching path data:", err);
        this.loading = false;
        this.pathGeojson = null;
        this.pathStart = null;
        this.pathEnd = null;
        this.isViewingPath = false;
      });
    },

    clearPath() {
      this.pathGeojson = null;
      this.pathStart = null;
      this.pathEnd = null;
      this.pathCoords = [];
      this.isViewingPath = false;
    },

    findCenter(item) {
      let geometry = {}
      geometry = {
        coordinates: [
          item.longitudine,
          item.latitudine            
        ]
      }
      this.setCenter(geometry, true)  
    },

    getLatLng(item) {
      let geometry = {}
      geometry = {
        coordinates: [
          item.latitudine,
          item.longitudine                      
        ]
      }   
      return geometry.coordinates;
    },

    zoomUpdated(zoom) {
      this.zoom = zoom;
    },

    centerUpdated(center) {
      this.center = center;
    },

    boundsUpdated(bounds) {
      this.bounds = bounds;
    },

    setCenter(geometry, zoomIn = false) {
      if (geometry && geometry.coordinates && geometry.coordinates.length >= 2) {
        this.center = latLng(geometry.coordinates[1], geometry.coordinates[0]);
        if (zoomIn) {
          this.zoom = 18;
        }
      }
    },

    getTimelineMarkerBg(item) {
      if (item.tipo_evento === 'inizio lavoro') return 'map-marker-start';
      if (item.tipo_evento === 'fine lavoro') return 'map-marker-end';
      if (item.tipo_evento === 'segnalazione') return 'map-marker-alert';
      return 'map-marker-team';
    },

    getTimelineMarkerIcon(item) {
      const intv = (item.intervento || '').toLowerCase();
      if (intv == 'buca') return 'mdi-traffic-cone';
      if (intv == 'sfalcio') return 'mdi-leaf';
      if (intv == 'segnaletica') return 'mdi-directions';
      if (intv == 'rifiuto' || intv == 'rifiuto_speciale') return 'mdi-delete-outline';
      if (intv == 'emergenza_carreggiata') return 'mdi-alert';
      if (intv == 'pulizia') return 'mdi-broom';
      return 'mdi-map-marker';
    },
    
    formatTimestampToLocalDate(ts) {
      if (!ts) return "-";
      let dateObj;
      if (typeof ts === 'string') {
        dateObj = new Date(ts);
      } else {
        dateObj = new Date(ts * 1000); // ms fallback
      }
      
      if (isNaN(dateObj.getTime())) {
        return ts;
      }

      const today = new Date();
      if (today.getDate() == dateObj.getDate() && today.getMonth() == dateObj.getMonth() && today.getFullYear() == dateObj.getFullYear()) {
        return `Oggi, ${dateObj.toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})}`;
      } else {
        return dateObj.toLocaleString([], {day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute:'2-digit'});
      }
    },

    mostraDettagli(item) {
      this.eventoSelezionato = item;
      this.$modal.show('dettagli-evento');
    },

    formatTimeOnly(dateTimeStr) {
      if (!dateTimeStr) return '';
      try {
        if (dateTimeStr.includes(' ')) {
          return dateTimeStr.split(' ')[1].substring(0, 5);
        }
        return dateTimeStr;
      } catch (e) {
        return dateTimeStr;
      }
    },

    // Viene cambiata la commessa dalla select
    cambioCommessaSelezionata() {
      localStorage.setItem("lotto", this.lotto);
      this.getGeojson();
    },

    caricaCommesse() {
      return contextStore.fetchCommesse().then(() => {
        this.getGeojson();
      });
    },

    cambiaMappa(layer) {
      this.mapLayer = layer;
      localStorage.setItem("mapLayer", this.mapLayer);
    }
  },
};
</script>

<style>
/* =========================================
   REALTIME MAP — Premium UI (RoadME DS)
   ========================================= */

/* ── Shared tokens from style.md ── */
.cw-section-title {
  font-size: 0.82rem; font-weight: 700;
  text-transform: uppercase; letter-spacing: 0.08em;
  color: #64748b; margin-bottom: 22px;
  display: flex; align-items: center;
}
.cw-step-num {
  width: 22px; height: 22px; border-radius: 50%;
  background: linear-gradient(135deg, #F7931E, #E07B00);
  color: #fff; font-size: 0.7rem; font-weight: 800;
  display: inline-flex; align-items: center; justify-content: center;
  margin-right: 10px; flex-shrink: 0;
}
.cw-label {
  font-size: 0.75rem; font-weight: 700;
  text-transform: uppercase; letter-spacing: 0.07em;
  color: #94a3b8; margin-bottom: 8px; display: block;
}
.cw-input-wrap { position: relative; display: flex; align-items: center; }
.cw-field-icon {
  position: absolute; left: 12px;
  color: #94a3b8; font-size: 1rem; z-index: 2; pointer-events: none;
}
.cw-input {
  width: 100%; height: 46px; padding: 0 14px 0 36px;
  border: 1.5px solid #e2e8f0; border-radius: 10px;
  background: #f8fafc; font-size: 0.92rem; font-weight: 500; color: #1e293b;
  transition: border-color 0.2s, box-shadow 0.2s; outline: none;
}
.cw-input:focus {
  border-color: #F7931E; box-shadow: 0 0 0 3px rgba(247,147,30,0.12); background: #fff;
}
.cw-select-wrap { position: relative; display: flex; align-items: center; }
.cw-select {
  width: 100%; height: 46px; padding: 0 38px 0 36px;
  border: 1.5px solid #e2e8f0; border-radius: 10px;
  background: #f8fafc; appearance: none; -webkit-appearance: none;
  font-size: 0.92rem; font-weight: 500; color: #1e293b;
  cursor: pointer; transition: border-color 0.2s, box-shadow 0.2s; outline: none;
}
.cw-select:focus {
  border-color: #F7931E; box-shadow: 0 0 0 3px rgba(247,147,30,0.12); background: #fff;
}
.cw-select-arrow {
  position: absolute; right: 14px;
  color: #94a3b8; font-size: 1rem; pointer-events: none;
}
.cw-btn-submit {
  display: inline-flex; align-items: center;
  padding: 10px 24px; border: none; border-radius: 30px;
  background: linear-gradient(135deg, #F7931E, #E07B00);
  color: #fff; font-size: 0.88rem; font-weight: 700;
  cursor: pointer; box-shadow: 0 4px 14px rgba(247,147,30,0.35);
  transition: all 0.2s;
}
.cw-btn-submit:hover:not(:disabled) {
  background: linear-gradient(135deg, #E07B00, #C96A00);
  box-shadow: 0 6px 18px rgba(247,147,30,0.45); transform: translateY(-1px);
}
.cw-btn-submit:disabled { opacity: 0.55; cursor: not-allowed; transform: none; }
.cw-footer {
  background: #fff; border-radius: 14px;
  padding: 18px 24px; border: 1px solid rgba(0,0,0,0.05);
  box-shadow: 0 2px 12px rgba(0,0,0,0.05);
}

/* ── Page-specific ── */

/* Header icon */
.au-header-icon {
  width: 48px; height: 48px; border-radius: 14px;
  background: linear-gradient(135deg, #F7931E, #E07B00);
  display: flex; align-items: center; justify-content: center;
  box-shadow: 0 4px 12px rgba(247,147,30,0.35); flex-shrink: 0;
}
.au-header-icon .mdi { color: #fff; font-size: 1.5rem; }

/* Card */
.au-card {
  background: #fff; border-radius: 16px;
  box-shadow: 0 2px 16px rgba(0,0,0,0.07);
  padding: 28px; border: 1px solid rgba(0,0,0,0.05);
}

/* Table */
.au-table { width: 100%; border-collapse: collapse; }
.au-table thead tr { border-bottom: 2px solid #f1f5f9; }
.au-table thead th {
  padding: 10px 16px; font-size: 0.72rem; font-weight: 700;
  text-transform: uppercase; letter-spacing: 0.07em; color: #94a3b8; background: #f8fafc;
}
.au-table tbody tr { border-bottom: 1px solid #f1f5f9; transition: background 0.15s; }
.au-table tbody tr:hover { background: #f8fafc; }
.au-table td { padding: 14px 16px; vertical-align: middle; }

/* Map Markers */
.map-marker-premium {
  width: 36px; height: 36px; border-radius: 50%;
  display: flex; align-items: center; justify-content: center;
  background: linear-gradient(135deg, #F7931E, #E07B00);
  box-shadow: 0 4px 12px rgba(247,147,30,0.4);
  border: 2px solid #fff;
}
.map-marker-start { background: linear-gradient(135deg, #10b981, #047857); box-shadow: 0 4px 12px rgba(16,185,129,0.4); }
.map-marker-end { background: linear-gradient(135deg, #f59e0b, #b45309); box-shadow: 0 4px 12px rgba(245,158,11,0.4); }
.map-marker-alert { background: linear-gradient(135deg, #ef4444, #b91c1c); box-shadow: 0 4px 12px rgba(239,68,68,0.4); }
.map-marker-team { background: linear-gradient(135deg, #F7931E, #E07B00); box-shadow: 0 4px 12px rgba(247,147,30,0.4); }
</style>